import { useQuery } from '@tanstack/react-query';
import { MarketingFiltersQueryKeys } from '@enums/react-query-keys';
import { ContentsMarketingFilter } from '@interfaces/models/contentsMarketingFilter';
import { getMarketingFilters } from '@api/contents';

const useMarketingFiltersQuery = () => {
  const { data: marketingFilters } = useQuery<ContentsMarketingFilter[]>({
    queryKey: [MarketingFiltersQueryKeys.MARKETING_FILTERS],
    staleTime: Infinity,
    queryFn: () => getMarketingFilters()
  });

  return {
    marketingFilters: marketingFilters || [],
  };
};

export default useMarketingFiltersQuery;
